<template>
<div id="OCBanners">

    <v-container fluid>
        <v-card height="70" class="elevation-0 px-2 ">
            <v-card-title>
                <v-row>
                    <v-col class="pa-0" cols="3">
                        <v-text-field clearable  label="Search" @input="onSearch" outlined v-model="search"></v-text-field>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-btn large class="primary text-capitalize elevation-0" title="Add Banner" @click="formDialog=true">Add Banner at Order Confirmation</v-btn>
                </v-row>
            </v-card-title>
        </v-card>
        <v-row>
            <v-col cols="12">
                <v-data-table :headers="headers" :items="banners" :server-items-length="bannersCount" :loading="loading"
                              :footer-props="{itemsPerPageOptions:rowsPerPageItems}" class="elevation-0 table-hover"
                              :options.sync="options" @update:page="$vuetify.goTo(0)" @update:options="onUpdateOptions">
                    <template v-slot:no-data>No Banners Available</template>
                    <template v-slot:no-results>No Banners Available</template>
                    <template v-slot:body="{ items }">
                        <tbody>
                       <!-- <draggable @end="drag=false; updateSequence()" @start="drag=true" group="people" v-model="banners" style="display: contents;" class="py-0"> -->
                            <tr v-for="(item,index) in items" :key="index" class="py-0">
                               <!-- <td class="px-4 my-0"><v-icon class="drag-icon">mdi-drag</v-icon></td>
                                <td class="px-4 my-0">{{index+1}}</td> -->
                                <td class="px-4 my-0">
                                    <v-avatar v-if="item.BannerImages.length" tile style="border: 1px solid grey; border-radius: 5px !important;" size="60" class="mr-6 avatar my-3" title="View Image"
                                              @click="openGallery(item.BannerImages)">
                                        <v-img :src="imgWpx(item.BannerImages[0].path, 200)" :alt="item.caption">
                                            <template v-slot:placeholder>
                                                <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                                <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                            </template>
                                        </v-img>
                                    </v-avatar>
                                    <span class="ellipsis b-name"><span :title="item.caption">{{ item.caption}}</span></span>
                                </td>
                                <td class="px-4 my-0">{{ Constants.MapRedirectTo[item.redirectTo]}}</td>
                                <td class="px-4 my-0">{{ moment(item.startTime).format('DD-MM-YYYY hh:mm A')}}</td>
                                <td class="px-4 my-0">{{ moment(item.endTime).format('DD-MM-YYYY hh:mm A')}}</td>
                                <td class="px-4 my-0">
                                    <template v-if="moment().unix()>moment(item.endTime).unix()">Expired</template>
                                    <template v-else-if="moment().unix()<moment(item.startTime).unix()">Upcoming</template>
                                    <template v-else>Ongoing</template>
                                </td>
                                <td class="px-4 my-0">{{ item.Clicks_aggregate&&item.Clicks_aggregate.aggregate.totalCount}}</td>
                                <td class="px-4 my-0">{{ item.Clicks_aggregate&&item.Clicks_aggregate.aggregate.uniqueCount}}</td>
                                <td class="px-4 my-0"><v-switch inset dense color="success" v-model="item.isActive" @click.stop="" @change="onUpdateStatusOfBanner(item)"/></td>
                                <td class="px-4 my-0">
                                    <v-menu nudge-bottom="25">
                                        <template v-slot:activator="{ on:menu }">
                                            <v-btn small icon v-on="{...menu}"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-list-item @click="onEditBanner(item)"><v-list-item-title>Edit</v-list-item-title></v-list-item>
                                            <v-list-item @click="onDeleteBanner(item, index)"><v-list-item-title>Delete</v-list-item-title></v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                            <tr v-if="!items.length" class="v-data-table__empty-wrapper"><td colspan="11" class="py-2">No Data Available</td></tr>
                       <!-- </draggable> -->
                        </tbody>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>
    </v-container>

    <BannerOCForm :dialog.sync="formDialog" :banners="banners" ref="banner-form"/>
    <ConfirmationDialog :confirmationMessage="confirm.message" @confirm="confirm.method" @close="confirm.closeMethod"
                        v-if="confirm.enable"/>
    <Snackbar :toaster="toaster"></Snackbar>
    <gallery id="gallery-oc-banners" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"></gallery>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from "moment";
import {debounce} from 'lodash'
import {SUBSCRIBE_BANNERS, SUBSCRIBE_BANNERS_COUNT} from "../../graphql/subscriptions/Banners";
// import draggable from 'vuedraggable';
import {DELETE_BANNER_BY_ID, UPDATE_BANNER_SEQUENCE, UPDATE_EXPIRED_BANNERS} from "../../graphql/mutations/Banners";
import Snackbar from "../../components/Common/Snackbar";
import ConfirmationDialog from "../../components/Common/ConfirmationDialog";
import {generate_UPDATE_RECORD} from "../../graphql/mutations/Orders";
import BannerOCForm from "./BannerOCForm";
let toaster = { enable: false, color: 'green', message: '' };
let options= {page: 1, itemsPerPage: 25, offset:0, limit:10};
export default {
    name: "OCBanners",
    components: {BannerOCForm, Snackbar, ConfirmationDialog},
    apollo: {
        $subscribe: {
            bannersCount:{
                query: SUBSCRIBE_BANNERS_COUNT,
                variables () { return { filter: this.filter, type: Constants.BannerType.OrderConfirmation}},
                result ({ data }) { this.bannersCount = data.bannersCount.aggregate.count },
            },
            banners:{
                query: SUBSCRIBE_BANNERS,
                variables () { return { filter: this.filter, type: Constants.BannerType.OrderConfirmation,
                    offset: this.options.offset, limit: this.options.limit}},
                result ({data}) { this.afterReceiveBanners(data.banners) },
            }
        }
    },
    data () {
        return {
            Constants, moment,
            user: JSON.parse(localStorage.user),
            search: '',
            banners: [],
            toaster: toaster,
            confirm: {enable: false},
            headers: [
               /* { text: '', value: 'drag' }, { text: 'SR NO', value: 'serialNo' }, */
                { text: 'BANNER TITLE', value: 'bannerTitle', width:260}, { text: 'REDIRECT TO', value: 'redirectTo'},
                { text: 'START TIME', value: 'startTime', width:120}, { text: 'END TIME', value: 'endTime', width:120},
                { text: 'VALIDITY', value: 'validity'},
                { text: 'TOTAL COUNT', value: 'totalCount'}, { text: 'UNIQUE COUNT', value: 'uniqueCount'},
                { text: 'IS ACTIVE', value: 'isActive'}, { text: 'ACTION', value: 'actions' },
            ],
            filter: '%%',
            formDialog: false,
            deleteParamters: null,
            galleryImages: [],
            galleryIndex: null,
            loading: true,
            bannersCount: 0,
            options: {...options}, rowsPerPageItems: [25, 50, 100, -1],
        }
    },
    methods: {
        afterReceiveBanners(banners){
            this.banners = banners;
            this.loading = false;
            let expiredIds = banners.filter(b => moment().unix()>moment(b.endTime).unix()&&b.isActive).map(b => b.id);
            if(!expiredIds.length) return;
            this.$apollo.mutate({
                mutation: UPDATE_EXPIRED_BANNERS,
                variables: { ids: expiredIds, obj:{isActive: false} }
            })
        },
        onUpdateOptions(val){
            if(val.itemsPerPage === -1){                                            //'ALL' Rows per page
                this.options.limit = this.bannersCount;                    //assign total count
                this.options.offset = 0
            }else{
                this.options.limit = val.itemsPerPage;
                this.options.offset = (val.page -1) * val.itemsPerPage;
            }
        },
        onSearch: debounce(function(val){
            this.filter = val?('%'+val+'%'):'%%';
            this.options = {...options}
        }, 500),
        onEditBanner(item){
            this.$refs['banner-form'].onEditBanner(item)
            this.formDialog = true
        },
        onDeleteBanner(row, index){
            this.confirm = {enable:true, message:'Are you sure want to delete Banner?',
                method:() => this.deleteBanner(row, index), closeMethod:() => this.confirm = {enable: false}};
        },
        deleteBanner(item, index){
            this.deleteBannerById(item.id)
            this.banners.splice(index, 1)
            this.updateSequence()
        },
        async deleteBannerById(id){
            let response = await this.$apollo.mutate({
                mutation: DELETE_BANNER_BY_ID,
                variables: { id: id }
            })
            if(response.data){
                this.confirm = {enable: false};
                this.toaster = {...toaster, enable:true, message: 'Banner deleted successfully'}
            }
        },
        async updateSequence(){
            let banner = this.banners.map(({id}, index) => ({ id, sequenceNo:index, createdBy:this.user.id, updatedBy:this.user.id}));
            await this.$apollo.mutate({
                mutation: UPDATE_BANNER_SEQUENCE,
                variables: {
                    banner,
                    updateColumns: ['sequenceNo']
                }
            })
        },
        onUpdateStatusOfBanner(row){
            this.confirm = {enable:true, message:`Are you sure want to ${row.isActive?'Active':'Inactive'} Banner?`,
                method:() => this.updateBannerStatus(row), closeMethod:() => this.revertStatus(row)};
        },
        revertStatus(row){
            row.isActive = !row.isActive;           /* Revert value */
            this.confirm = {enable: false};
        },
        updateBannerStatus(item){
            let obj = { isActive: item.isActive, updated_at : moment().format(), updatedBy: this.user.id}
            this.updateRecord(item.id, obj, 'Banners', () => {
                this.toaster = {...toaster, enable:true, message: `Status Updated Successfully`};
                this.confirm = {enable: false};
            })
        },
        async updateRecord(id, obj, table, callback){
            let response = await this.$apollo.mutate({
                mutation: generate_UPDATE_RECORD(table),
                variables: { id: id, obj: obj}
            })
            if(response.data) callback()
        },
        openGallery(arr){
            arr.forEach(m => m.type = m.type||'IMAGE');
            this.galleryImages = arr.map(m => {return {
                href: this.imgWpx(m.path, 900),
                type: m.type.toLowerCase() + '/' + m.path.split('.').pop()
            }})
            this.galleryIndex = 0
        }
    }
}
</script>



<style scoped>
.drag-icon{
    visibility: hidden;
    cursor: pointer;
}
/deep/ .table-hover tbody tr:hover .drag-icon  {
    visibility: visible;
}
.avatar{
    cursor: pointer;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.b-name {
    display: inline-block;
    vertical-align: middle;
    width: 140px;
    max-width: 140px;
}
.f-12{
    font-size: 12px;
}
</style>
